import { http } from '@/http'

export default {
  list(params) {
    return http.get('/expense-lines', { params })
  },
  listActive() {
    return http.get('/expense-lines/active')
  },
  get(id) {
    return http.get(`/expense-lines/${id}`)
  },
  save(data) {
    return http.post('/expense-lines', data)
  },
  update(id, data) {
    return http.put(`/expense-lines/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/expense-lines/${id}/status`, null, { params: { status } })
  },
}
